var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "config-group small-12 column d-flex flex-column align-items-center conf-3Dmodel",
    },
    [
      _c("div", { staticClass: "config-item w-100 position-relative" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-wrap align-items-center input-calc h-spacing-4",
          },
          _vm._l(_vm.conf3dModel, function (value, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass:
                  "input-calc__container position-relative d-flex align-items-center flex-child-auto",
              },
              [
                _c("div", { staticClass: "flex-child-auto" }, [
                  _c(
                    "div",
                    { staticClass: "config-item__info d-inline-flex" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "input-calc__label",
                          attrs: { for: key },
                        },
                        [_vm._v(_vm._s(_vm.getPrintQLabel(key)))]
                      ),
                      _vm._v(" "),
                      _c("Tooltip", {
                        attrs: { infoText: _vm.getToolTip(key) },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "text-center w-100",
                    class: {
                      error: _vm.configuratorService
                        .byConfigoptionType("Printq")
                        .dynamicValues.printQErrorFields?.includes(key),
                    },
                    attrs: { type: "number", required: "", id: key },
                    domProps: { value: value },
                    on: {
                      change: function ($event) {
                        return _vm.dimensionChanged(key, $event)
                      },
                    },
                  }),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }